import { Routes, RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { ModalGuard } from "../../routerGuards/modal.guard";
import { MedicalReportDetailsComponent } from "./medical-report-details/medical-report-details.component";
import { PatientArea } from "../../models/roles";

export function entityKeyResolver(name: Extract<keyof PatientArea, string>): string { return name; };

export const medicalReportRoutes: Routes = [
    {
        path: '',
        children: [
            {
                path: 'details',
                component: MedicalReportDetailsComponent,
                canActivate: [ModalGuard]
            }],
        data: {            
            entityPermissionKey: entityKeyResolver("medicalReports")
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(medicalReportRoutes)],
    exports: [RouterModule],
    providers: [ModalGuard]
})
export class MedicalReportRoutingModule { }
